module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/client_two-43bd413df377518a396ac79fdc529924.png";